import { cookieService } from '@bfa/nextjs-common/services';
import { NextPageContext } from 'next';

import { GQLProgram } from '../../../gql.generated';
import { initApolloClient } from '../../apollo';
import CookieName from '../../cookies/cookieName';
import GET_USER_SUB_DATA from '../graphql/queries/GET_USER_SUB_DATA';

const getSuccessfulSubscriptionsFlags = (programs?: GQLProgram[]) => {
  const initialSubscribedPrograms = {
    subscribedToGB: false,
    subscribedToGBP: false,
    subscribedToGBX: false,
  };
  return (
    programs?.reduce((accum, program: GQLProgram) => {
      switch (program) {
        case GQLProgram.GLAMBAG:
          return { ...accum, subscribedToGB: true };
        case GQLProgram.FULLSIZE:
          return { ...accum, subscribedToGBP: true };
        case GQLProgram.GBX:
          return { ...accum, subscribedToGBX: true };
        default:
          return accum;
      }
    }, initialSubscribedPrograms) ?? initialSubscribedPrograms
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getGtmEventsProps = async (
  ctx: NextPageContext,
  teamName?: string,
  extraData?: Record<string, string>
) => {
  const client = initApolloClient({}, ctx);

  const sucProgramsCookie = cookieService.getCookie(
    ctx,
    CookieName.SUB_CONFIRMATION_SUCCESS_PROGRAM
  );

  const successfulPrograms = sucProgramsCookie?.split(',') as GQLProgram[];

  const cookieFlow = cookieService.getCookie(
    ctx,
    CookieName.SUB_CONFIRMATION_FLOW
  );

  const gqlVariables = {
    ...getSuccessfulSubscriptionsFlags(successfulPrograms),
  };

  const { data } = await client.query({
    query: GET_USER_SUB_DATA,
    variables: gqlVariables,
    context: {
      teamName: teamName || 'NO_TEAM',
    },
  });

  const userSid =
    cookieService.getCookieAsJson(ctx, CookieName.IPCUR)?.sid || '';

  return {
    ...extraData,
    flow: cookieFlow,
    gbSubscription: data?.me?.gbSubscription,
    gbpSubscription: data?.me?.gbpSubscription,
    gbxSubscription: data?.me?.gbxSubscription,
    userEmail: data?.me?.details?.email,
    userId: data?.me?.details?.id,
    userSid,
  };
};
